import React from "react";
import {
  FaGithub,
  FaExternalLinkAlt,
  FaLock,
  FaPalette,
  FaCode,
} from "react-icons/fa";

const ProjectCard = ({ project }) => {
  const getIcon = (category) => {
    switch (category) {
          case "Cybersecurity":
        return <FaLock className="text-emerald-500" />;
      case "Web Development":
        return <FaCode className="text-blue-500" />;
      case "Graphic Design":
        return <FaPalette className="text-purple-500" />;
      default:
        return <FaCode />;
    }
  };

  const getMaskClass = (category) => {
    switch (category) {
      case "Cybersecurity":
        return "bg-cyan-500/30 mix-blend-multiply";
      case "Graphic Design":
        return "bg-purple-500/20 mix-blend-overlay";
      case "Web Development":
        return "bg-blue-500/20 mix-blend-overlay";
      default:
        return "bg-emerald-500/20 mix-blend-overlay";
    }
  };

  return (
    <div className="relative overflow-hidden rounded-xl
                    bg-gradient-to-br from-white to-white/90
                    dark:from-gray-800/80 dark:to-gray-900/40
                    backdrop-blur-sm
                    border border-gray-200 dark:border-gray-700
                    shadow-md
                    transition-all duration-300 hover:shadow-lg hover:scale-[1.02]
                    h-full flex flex-col">

      {/* Image Section – slightly taller than before for better visibility */}
      <div className="relative h-40 shrink-0 overflow-hidden group">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-50" />
        <div className={`absolute inset-0 ${getMaskClass(project.category)}`} />

        <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-1 rounded-full bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm border border-gray-200 dark:border-gray-700/50 z-10">
          {getIcon(project.category)}
          <span className="text-sm font-medium text-gray-900 dark:text-white">
            {project.category}
          </span>
        </div>
      </div>

      {/* Content – balanced padding */}
      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2 line-clamp-2">
          {project.title}
        </h3>

        <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 line-clamp-2 flex-1">
          {project.description}
        </p>

        {/* Buttons */}
        <div className="flex gap-2 mt-auto">
          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center px-3 py-1.5 rounded-lg bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-300 text-sm"
            >
              <FaGithub className="mr-1" />
              Code
            </a>
          )}

          {project.demo && (
            <a
              href={project.demo}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center px-3 py-1.5 rounded-lg 
                         bg-gradient-to-r from-emerald-600 to-cyan-500 
                         text-white font-semibold hover:shadow-lg 
                         transition-shadow duration-300 text-sm"
            >
              <FaExternalLinkAlt className="mr-1" />
              Live Demo
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;